const state = {
  carrierApptatForm: {
    oid: '',
    jyoCarrier: '', // 10_tpec, 80_hmde

    isSooner: true,
    soonerApptAt: '',
    deliveryApptAt0: '',
    deliveryApptAt1: '',
  },
}

const getters = {
}

const mutations = {
  setCarrierApptatForm (state, value) {
    state.carrierApptatForm = value
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
